<div class="sw-cms-el-moorl-twig">
    <pre>
        {{ element.config.contentHTML.value }}
    </pre>
</div>